import React, { useEffect, useState } from "react";
import { Button, CardWithLable, Table, Spinner } from "@public/ui-toolkit";
import { useHistory } from "react-router";
import { Row, Col, Input, Modal, Tag, Tooltip, Spin } from "antd";
import moment from "moment";
import jwtDecode from "jwt-decode";
import { alertService } from "../Alert";
import { useRef } from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const MeetingDetailComponent = ({ match, getMeeting, portal, deleteMeetings, updateAttendeeStatus, updateMeetingInGoogle, updateMeetingInOutlook }) => {
  const history = useHistory();
  const [attendee, setAttendee] = useState({});

  const { TextArea } = Input;
  const getUserDetails = () => {
    var token = sessionStorage.getItem("token") ?? localStorage.getItem("token");
    if (token !== null) {
      return jwtDecode(token);
    }
  };
  const {
    status,
    startTime,
    allocator,
    chimeMeetingStatus,
    description,
    appointmentAttendees,
    hedgeUser,
    topic,
    fund,
    loading,
    url,
  } = getMeeting || {};
  const [startDate, setStartDate] = useState(startTime);
  const [company, setCompany] = useState("");
  const [open, setOpen] = useState(false);
  const invitationRef = useRef(null);
  const [connection, setConnection] = useState();
  const [meeting, setMeeting] = useState();
  useEffect(() => {
    var user = getUserDetails();
    if (appointmentAttendees?.length > 0) {
      var appointment = appointmentAttendees?.find(x => x.userAttendeeId == Number(user.UserId));
      if (appointment != null) {
        setAttendee(appointment);
      }
    }
    var utcDate = new Date(startTime);
    var timezoneOffset = -utcDate.getTimezoneOffset();
    var localDate = new Date(utcDate.getTime() - (timezoneOffset * 60000));
    setStartDate(localDate);
    var message = portal === "allocator" ? getMeeting?.hedgefund?.name : getMeeting?.allocator?.name;
    setCompany(message);

  }, [appointmentAttendees]);


  const attendeeStatus = [
    { name: "Pending", key: 0 },
    { name: "Accepted", key: 1 },
    { name: "Rejected", key: 2 },
  ];
  const typeEnum = [
    { name: "Allocator", key: 0 },
    { name: "HedgeFund", key: 1 },
    { name: "FCN", key: 2 },
  ]

  const chimeStatusEnum = [
    { name: "Pending", key: 0 },
    { name: "Failed", key: 1 },
    { name: "Success", key: 2 },
  ]
  const columns = [
    { name: "Name", key: "userAttendee", childKey: "fullName" },
    {
      name: "Email",
      key: "userAttendee",
      childKey: "emailAddress",
    },
    {
      name: "Type",
      key: "type",
      renderContent: (t) => {
        return (
          <span className="badge badge-pill badge-secondary">
            {typeEnum[t?.type]?.name}
          </span>
        );
      },
    },
    {
      name: "Attendee Status",
      key: "status",
      renderContent: (t) => {
        return <span className="badge badge-pill badge-secondary">{attendeeStatus[t?.status]?.name ?? "N/A"}</span>
      },
    },
  ];

  useEffect(() => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token")
    const connect = new HubConnectionBuilder()
      .withUrl(`${window._env_.NOTIFICATION_URL}?access_token=${token}`)
      .withAutomaticReconnect()
      .build();

    setConnection(connect);
    connect.onclose = connectToHub();
  }, []);

  useEffect(() => {
    if (connection) {
      connectToHub();
    }
  }, [connection]);

  var connectToHub = () => {
    if (connection) {
      connection
      .start()
      .then(() => {
          connection.on("GetMeetingChimeStatus", (message) => {
            setMeeting(message?.status)
            // dispatch({ type: ADD_SINGLE_MESSAGES, message });
          });
        })
        .catch((error) => console.log(error));
    }
  };
  const UpdateStatus = (value) => {
    const appointmentAttendee = {
      appointmentId: attendee.appointmentId,
      userAttendeeId: attendee.userAttendeeId,
    };
    if (value === "Yes") {
      appointmentAttendee.status = 1;
    } else {
      appointmentAttendee.status = 2;
    }
    updateAttendeeStatus(appointmentAttendee);
  }

  const UpdateMeetingInGoogleCalendar = () => {

    var userAttendee = getMeeting?.appointmentAttendees?.map((item) => {
      return ({ 'email': item?.userAttendee?.emailAddress });
    });

    var dateTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const date1 = new Date(getMeeting?.startTime);
    const date2 = new Date(getMeeting?.endTime);
    const diffTime = Math.abs(date2 - date1);
    const diffMint = Math.ceil(diffTime / (1000 * 60));
    const date3 = new Date(getMeeting?.startLocalTime);
    date3.setMinutes(date3.getMinutes() + diffMint);
    var endDate = moment(date3).format("yyyy-MM-DDThh:mm:00")

    var event = {
      'summary': getMeeting?.topic + " with " + company,
      // 'location': '800 Howard St., San Francisco, CA 94103',
      'description': getMeeting?.description,
      'start': {
        'dateTime': getMeeting?.startLocalTime,
        'timeZone': dateTimezone
      },
      'end': {
        'dateTime': endDate,
        'timeZone': dateTimezone
      },
      'attendees': userAttendee,
      'sendUpdates': 'all',
      'sendNotifications': true,
      'reminders': {
        'useDefault': false,
        'overrides': [
          { 'method': 'email', 'minutes': 24 * 60 },
          // { 'method': 'popup', 'minutes': 10 }
        ]
      }
    }
    updateMeetingInGoogle(event);
  }

  const UpdateMeetingInOutlookCalendar = () => {

    var userAttendee = getMeeting?.appointmentAttendees?.map((item) => {
      return ({
        "emailAddress" :
        {
          "address": item?.userAttendee?.emailAddress,
          "name": item?.userAttendee?.fullName
        },
      }
      );
    });

    const date1 = new Date(getMeeting?.startTime);
    const date2 = new Date(getMeeting?.endTime);
    const diffTime = Math.abs(date2 - date1);
    const diffMint = Math.ceil(diffTime / (1000 * 60));
    const date3 = new Date(getMeeting?.startLocalTime);
    date3.setMinutes(date3.getMinutes() + diffMint);
    var endDate = moment(date3).format("yyyy-MM-DDThh:mm:00");

    const event = {
      "subject": getMeeting?.topic + " with " + company,
      "body": {
        "contentType": "HTML",
        "content": getMeeting?.description,
      },
      "start": {
        "dateTime": getMeeting?.startLocalTime,
        "timeZone": getMeeting?.timeZoneValue
      },
      "end": {
        "dateTime": endDate,
        "timeZone": getMeeting?.timeZoneValue
      },
      "attendees": userAttendee,
      allowNewTimeProposals: true,
    };
    updateMeetingInOutlook(event)

  }
  const zoomMeetingInvitation =
    `${company} is inviting you to a scheduled fcn meeting. 
  
Topic : ${topic}
Time : ${startDate}

Join FCN Meeting
${origin}/${url !== null ? url : meeting?.meetingUrl}`;

  const copyToClipboard = (meetingUrl) => {
    let url = origin + "/" + meetingUrl;
    navigator.clipboard.writeText(url);
    alertService.success("Copy to Clipboard", { autoClose: true })
  }

  const InvitationToClipboard = () => {
    let reference = invitationRef.current.resizableTextArea.textArea;
    reference.select();
    navigator.clipboard.writeText(reference.value);
    setOpen(false);
    alertService.success("Meeting invitation copy to clipboard", { autoClose: true });
  };

  return (
    <main>
      <div className="main-inner">
        <div className="container">
          <div
            className="
            manage-schedule
            rounded-large
            box-shadow
            bg-white
            p-xxl-5 p-md-4 p-1
            py-3
            mb-sm-5 mb-4
            mt-4
          "
          >

            {getMeeting?.loading || !Object.keys(getMeeting).length ? (
              <Spinner />
            ) : (
              <>
                <div className="text-center mb-5">
                  <h2 className="stylish-title text-blue">FCN Virtual Meeting Details</h2>
                </div>
                <div className="rounded bg-white p-2">
                  <div className="row mt-2 ">
                    <div className="col-lg-6">
                      <h3>{topic + " with " + company} {" "}
                        {getMeeting.chimeMeetingStatus || meeting?.status === 2 ? (
                          <Tag color={"success"}>
                            <Tooltip title={"Chime Status"}>
                              {chimeMeetingStatus ? chimeStatusEnum[chimeMeetingStatus]?.name : chimeStatusEnum[meeting?.status]?.name}
                            </Tooltip>
                          </Tag>
                        ) : (
                          <Spin indicator={antIcon} />
                        )}
                      </h3>
                    </div>
                    <div className="col-lg-6">
                      <Button btnStyle={{ float: "right" }} btnName={"Delete Meeting"} onClick={deleteMeetings} btnType="primary" />
                      {(getMeeting.appointmentStatus === 0 ||
                        getMeeting.appointmentStatus === 1 ||
                        getMeeting.appointmentStatus === 2) &&
                        getMeeting.type === 0 && (
                          <Button
                            btnStyle={{ float: "right" }}
                            btnName={"Join Meeting"}
                            btnType="primary"
                            onClick={() =>
                              history.push(
                                `${url !== null ? url : meeting?.meetingUrl}&name=${getUserDetails()?.FullName}`
                              )
                            }
                            disabled={getMeeting.chimeMeetingStatus || meeting?.status === 2 ? false : true || status === "Expired" || status === "Done" }
                          />
                        )}
                      {(getMeeting.appointmentStatus === 0 ||
                        getMeeting.appointmentStatus === 1 ||
                        getMeeting.appointmentStatus === 2) &&
                        getMeeting.type === 0 && (
                          <Button
                            btnStyle={{ float: "right" }}
                            btnName={"Copy Meeting Invitation"}
                            btnType="primary"
                            onClick={() => setOpen(true)}
                          />
                        )}
                    </div>
                  </div>
                  <div className="for-tabs mt-3">
                    <div className="hf-horizontal-tabs row" style={{ maxWidth: "100%" }}>
                      <div className="hf-horizontal-tabs-navBox col-lg-7 col-xl-7">
                        <ul className="nav nav-tabs" style={{ fontSize: "18px" }} id="myTab" role="tablist">
                          {topic && (
                            <li className="nav-item">
                              Topic:
                              <span className="text-blue ml-2">
                                {topic}
                              </span>
                            </li>
                          )}
                          {/* || chimeStatus  === 2 */}
                          {/* {meeting?.meetingUrl !== undefined || url && ( */}
                          <li className="nav-item">
                            Meeting Url:
                            <span className="text-blue ml-2">{origin + "/"}{url !== null ? url : meeting?.meetingUrl}</span> {" "}
                            <span style={{ cursor: "pointer" }}><i class="fa fa-copy" onClick={() => copyToClipboard(url !== null ? url : meeting?.meetingUrl)}></i></span>
                          </li>
                          {/* )} */}
                          {startDate && (
                            <li className="nav-item">
                              Start Time:
                              <span className="text-blue ml-2">
                                {moment(startDate).format("hh:mm A")}
                              </span>
                            </li>
                          )}
                          {status && (
                            <li className="nav-item">
                              Status:
                              <span className="text-blue ml-2">{status}</span>
                            </li>
                          )}
                          {/* <li className="nav-item">
                            Chime Status:
                            <span className="text-blue ml-2">{chimeMeetingStatus ? chimeStatusEnum[chimeMeetingStatus]?.name : chimeStatusEnum[chimeStatus]?.name}</span>
                          </li> */}
                          {portal && (
                            <li className="nav-item">
                              Allocator:
                              <span className="text-blue ml-2">
                                {allocator.name}
                              </span>
                            </li>
                          )}
                          {/* {portal && (
                            <li className="nav-item">
                              Tenancy:
                              <span className="text-blue ml-2">
                                {allocator.tenancyName}
                              </span>
                            </li>
                          )} */}
                          {description.length < 150 && (
                            <li className="nav-item">
                              Description:
                              <span className="text-black ml-2">
                                {description}
                              </span>
                            </li>
                          )}
                        </ul>
                      </div>
                      <div className="hf-horizontal-tabs-contentBox col-lg-5 col-xl-5">
                        <div
                          className="
                                    tab-content
                                    rounded-large
                                    bg-lightgrey2
                                    p-md-4 p-3
                                    h-100
                                  "
                          id="myTabContent"
                        >
                          <div>
                            <div className="header">
                              <span style={{ display: "inline-block", fontSize: "18px", fontWeight: "700" }}>Attendees</span>
                              {(() => {
                                if (attendee?.type == 1 && attendee?.status == 0) {
                                  return (
                                    <ul style={{ float: "right" }}>
                                      <li style={{ display: "inline-block" }}>
                                        <Button type="primary" btnName={"Yes I am In"} onClick={() => UpdateStatus("Yes")} />
                                      </li>
                                      <li style={{ display: "inline-block" }}><Button btnName={"Not Available"} onClick={() => UpdateStatus("No")} /></li>
                                    </ul>
                                  )
                                } else if (attendee?.type == 1 && attendee?.status == 2) {
                                  return "";
                                } else {
                                  return (
                                    <ul style={{ float: "right" }}>
                                      <li style={{ display: "inline-block" }}><Button type="primary" btnName={"Google Calendar"} onClick={UpdateMeetingInGoogleCalendar} /></li>
                                      <li style={{ display: "inline-block" }}><Button type="primary" btnName={"Outlook Calendar"} onClick={UpdateMeetingInOutlookCalendar} /></li>
                                    </ul>
                                  )
                                }
                              })()}

                            </div>
                            <Table columns={columns} data={appointmentAttendees} />
                          </div>
                          <div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {description.length >= 150 && (
                    <li className="nav-item mt-2">
                      <b>Description</b>:
                      <span className="text-black ml-2">
                        {description}
                      </span>
                    </li>
                  )}
                </div>

              </>
            )}
          </div>
        </div>
      </div>
      <Modal
        title={"Copy Meeting Invitation"}
        centered
        open={open}
        closable={false}
        footer={[
          <Button
            btnName="Cancel"
            onClick={() => setOpen(false)}
            btnType="primary"
          />,
          <Button
            btnName="Copy Meeting Invitation"
            onClick={InvitationToClipboard}
            btnType="primary"
          />,
        ]}
        width={800}
      >
        <Row>
          <Col span={24} >
            <TextArea ref={invitationRef} rows={8} style={{ width: "100%" }} value={zoomMeetingInvitation} readOnly />
          </Col>
        </Row>

      </Modal>
    </main>
  );
};

export default MeetingDetailComponent;
